var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFailedCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 87",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.201 12.936c-2.852 5.178-4.759 13-5.719 23.464-.147 2.067-.22 4.142-.22 6.224s.073 4.327.22 6.733c.299 8.004 1.974 15.186 5.026 21.546 2.301 4.796 5.025 8.374 8.171 10.733a9.6 9.6 0 005.76 1.92h4.918a7.245 7.245 0 007.246-7.246c0-2.84-.775-6.633-2.325-11.38a6.4 6.4 0 00-5.065-4.333l-5.645-.91a3.2 3.2 0 01-2.463-1.975c-1.874-4.7-2.81-10.178-2.81-16.433 0-6.088.901-10.919 2.704-14.492a3.2 3.2 0 012.495-1.738l5.327-.607a6.4 6.4 0 005.416-4.553c1.577-5.362 2.366-9.265 2.366-11.709a6.488 6.488 0 00-6.488-6.487h-5.454a9.6 9.6 0 00-5.92 2.042c-2.898 2.271-5.412 5.338-7.54 9.201z",
    fill: "#8D9BAD"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EDF4FC",
    d: "M80 4.954L4 78.955"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EC8373",
    d: "M80 11L6 82.955"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedCallIcon);
export default __webpack_public_path__ + "static/media/FailedCallIcon.bc78ca2ea24745867a3baa367bfc58a9.svg";
export { ForwardRef as ReactComponent };